<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import debounce from '../utils/debounce.js';

  export let stepName;
  export let stepNumber;
  export let maxSteps;
  export let currentSelection;
  export let active;

  const dispatch = createEventDispatcher();

  let section = {};
  section.title = stepName;
  section.description = '';

  function viewDetails(title, htmlContent) {
    dispatch('viewDetails', {
			content: htmlContent,
      title: title
		});
  }

  onMount(() => { 

    console.log(currentSelection)
    if (stepName === "Tapahtuman tiedot") {
      section.description = "Täytä kaikki kentät huolellisesti. Kaikki kentät lisätietoja lukuunottamatta on pakollisia.";

      const formNode = document.getElementById(`${stepName}-form`);
      const filledInputs = [];
      const formRequiredInputs = formNode.querySelectorAll('[required]');

      let debounceTimeout;
      let formData = JSON.parse(sessionStorage.getItem('jc_submitted_data')) || {};

      const dispatchForm = () => {
        const formInputs = formNode.querySelectorAll('[name]');
        let formContent = "";
        formInputs.forEach((formInput) => {
          formData[formInput.getAttribute('name')] = formInput.value

          formContent += `
            ${formInput.getAttribute('name')}: ${formInput.value}\n
            ----`
          ;
        });
        dispatch('formSubmit', {
          content: formContent
        });
        console.log('formSubmit', formContent)
        sessionStorage.setItem('jc_submitted_data', JSON.stringify(formData))
      }

      formRequiredInputs.forEach((input) => {

        if (formData[input.getAttribute('name')]) {
          input.value = formData[input.getAttribute('name')];
          input.dispatchEvent(new Event('input'))
          if (filledInputs.indexOf(input.getAttribute('name')) == -1) {
            filledInputs.push(input.getAttribute('name'))
          }
          if (filledInputs.length === formRequiredInputs.length) {
            dispatchForm()
          }
        }

        input.addEventListener('input', function(e) {
          const debounce = () => {
            if (input.value != "") {
              if (filledInputs.indexOf(input.getAttribute('name')) == -1) {
                filledInputs.push(input.getAttribute('name'))
              }
              formData[input.getAttribute('name')] = input.value;
              console.log(input.getAttribute('name'),'=>',input.value)
              if (filledInputs.length === formRequiredInputs.length) {
                dispatchForm()
              }
            }
          }

          clearTimeout(debounceTimeout);
          debounceTimeout = setTimeout(debounce, 200);
        });
      })
    } else if (stepName === "Yhteenveto") {
      section.selection = [];
      currentSelection.forEach((step) => {
        for (const product of step) {
          section.selection.push(product)
        }
      });

      console.log('section selection', section.selection)
    }
  })
</script>

<section class:active={active === true}>
  <header class="section-header">
    <h1 class="section-title title">{section.title}</h1>
    <h2 class="section-subtitle subtitle">Vaihe {stepNumber} / {maxSteps}</h2>
  </header>
  <p class="section-description content">{@html section.description}</p>
  {#if stepName === "Tapahtuman tiedot"}
    <div id="{stepName}-form" class="columns">
      <div class="column is-full-mobile is-half">
        <h5 class="is-size-5 mb-4 has-text-weight-bold">Tapahtumapaikka</h5>
        <div class="field">
          <label for="katuosoite" class="label">Katuosoite <span class="has-text-danger">*</span></label>
          <div class="control">
            <input id="katuosoite" name="katuosoite" type="text" autocomplete="street-address" placeholder="Katuosoite" class="input is-medium" required/>
          </div>
        </div>

        <div class="field">
          <label for="kaupunki" class="label">Kaupunki <span class="has-text-danger">*</span></label>
          <div class="control">
            <input id="kaupunki" name="kaupunki" type="text" autocomplete="address-level2" placeholder="Kaupunki" class="input is-medium" required/>
          </div>
        </div>

        <hr>

        <h5 class="is-size-5 mb-4 has-text-weight-bold">Tapahtuman ajankohta</h5>
        <div class="field">
          <label for="pvm" class="label">Tapahtuman päivämäärä <span class="has-text-danger">*</span></label>
          <div class="control">
            <input id="pvm" name="päivämäärä" type="date" placeholder="" class="input is-medium" required/>
          </div>
        </div>

        <div class="field">
          <label for="time" class="label">Alkaa klo. <span class="has-text-danger">*</span></label>
          <div class="control">
            <input id="time" name="alkaa klo" type="text" placeholder="16.30" class="input is-medium" required/>
          </div>
        </div>

        <label for="duration" class="label">Kesto tunteina (noin)<span class="has-text-danger">*</span></label>
        <div class="field has-addons">
          <div class="control">
            <input id="duration" name="kesto tunteina" type="number" placeholder="Kesto tunteina, esim 5" class="input is-medium" required/>
          </div>
          <div class="control">
            <button class="button is-medium is-static">tuntia</button>
          </div>
        </div>
      </div>

      <div class="column is-full-mobile is-half">
        <h5 class="is-size-5 mb-4 has-text-weight-bold">Tapahtuman luonne</h5>
        <div class="field">
          <label for="category" class="label">Valitse tapahtuman luonne <span class="has-text-danger">*</span></label>
          <div class="control">
            <div class="select is-medium">
              <select id="category" name="tapahtuman luonne">
                <option>Häät</option>
                <option>Syntymäpäivät</option>
                <option>Yritystapahtumat</option>
                <option>Muu, kerro lisätiedoissa</option>
              </select>
            </div>
          </div>
        </div>

        <label for="visitors" class="label">Osallistujien henkilömäärä (noin)<span class="has-text-danger">*</span></label>
        <div class="field has-addons">
          <div class="control">
            <input id="visitors" name="odotettu kävijämäärä" type="number" placeholder="Odotettu kävijämäärä, esim 150" class="input is-medium" required/>
          </div>
          <div class="control">
            <button class="button is-medium is-static">hlö</button>
          </div>
        </div>

        <div class="field">
          <label for="details" class="label">Lisätiedot</label>
          <div class="control">
            <textarea id="details" name="lisätiedot" class="textarea input is-medium" placeholder="Vapaavalintainen viesti"></textarea>
          </div>
        </div>
      </div>
    </div>
  {:else if stepName === "Yhteenveto"}
    {#if section.selection}
      {#each section.selection as product}
        <article class="media">
          <figure class="media-left">
            <p class="image is-64x64">
              {#if product.images && product.images.length > 1}
                <img class="swiper-igm" src="{product.images[0].src}" loading="lazy" alt="{product.title}"/>
              {:else}
                <div class="swiper-img placeholder">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-image"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                </div>
              {/if}
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <h5>{product.title}</h5>
              <small style="max-width: 65ch; display: inline-block;">{product.description}</small>
            </div>
          </div>
          <div class="media-right">
            {parseFloat(product.variants[0].price.amount || 0)} €
          </div>

        </article>
      {/each}
    {/if}
  {/if}
</section>


<style>
  section {
    display: none;
  }
  section.active {
    display: block;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .section-title {
    padding: 0;
    margin: 0;
  }
  .section-subtitle {
    text-transform: uppercase;
    font-weight: 400;
    font-size: 0.875em;
  }

  .section-description {
    text-align: left;
    max-width: 60rem;
  }

  .selection-target {
    cursor: pointer;
  }

</style>